'use strict';
import isNumber from 'lodash/isNumber';
import random from 'lodash/random';


export const AvatarGradientColors = [
  ['#CD4091', '#69467E'],
  ['#9B00FF', '#0063FF'],
  ['#009CFF', '#0063FF'],
  ['#24DDF5', '#1FA2FF'],
  ['#11998E', '#38EF7D'],
  ['#DCE35B', '#45B649'],
  ['#FFC849', '#FF3D3D'],
  ['#FFE259', '#FFA751'],

  ['#69467E', '#CD4091'],
  ['#0063FF', '#9B00FF'],
  ['#0063FF', '#009CFF'],
  ['#1FA2FF', '#24DDF5'],
  ['#38EF7D', '#11998E'],
  ['#45B649', '#DCE35B'],
  ['#FF3D3D', '#FFC849'],
  ['#FFA751', '#FFE259'],
];

export const AvatarColors = [
  '#F44336', //Red
  '#E91E63', //Pink
  '#9C27B0', //Purple
  '#3F51B5', //Indigo
  '#2196F3', //Blue
  '#03A9F4', //Light Blue
  '#00BCD4', //Cyan
  '#009688', //Teal
  '#4e9e6e', //Green
  '#76b58f', //Light Green
  '#f5e559', //Yellow
  '#FFC107', //Amber
  '#FF9800', //Orange
  '#FF5722' //Deep Orange
];

const fontColors = [
  '#fff', //Red
  '#fff', //Pink
  '#fff', //Purple
  '#fff', //Indigo
  '#fff', //Blue
  '#fff', //Light Blue
  '#fff', //Cyan
  '#fff', //Teal
  '#fff', //Green
  '#fff', //Light Green
  '#565339', //Yellow
  '#565339', //Amber
  '#fff', //Orange
  '#fff' //Deep Orange
];

AvatarColors.isColor = isColor;
AvatarColors.getColor = getColor;
AvatarColors.getGradientColor = getGradientColor;
AvatarColors.getFontColor = getFontColor;
AvatarColors.getColorClass = getColorClass;
AvatarColors.getRand = getRand;

function isColor(idx) {
  return isNumber(idx) && idx < AvatarColors.length;
}

export function getGradientColor(idx) {
  return isNumber(idx) ? AvatarGradientColors[idx] : AvatarGradientColors[0];
}

function getColor(idx) {
  return isNumber(idx) ? AvatarColors[idx] : '#eee';
}

function getFontColor(idx) {
  return isNumber(idx) ? fontColors[idx] : '#222';
}

function getColorClass(idx) {
  return 'assignedTo-color-' + idx;
}

function getRand() {
  return random(AvatarColors.length - 1);
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/domain/AvatarColors.js